module.exports = __webpack_public_path__ + "img/MDI-certificate.da7edd1a.svg";